import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  Label,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../../helpers/Utils';
import {
  gAPI_Property_List_By_Group,
  API_OracleOpera_Integration,
} from '../../../../../../constants/APIs';
import {
  ReservationIntegrationsData,
  PreCheckinRequestData,
  HouseKeepingData,
  RegformData,
} from '../../data/OracleOperaFeatures';
import Validation from '../../../../../../components/Validation';
export default function OracleOperaIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [inputData, setInputData] = useState({
    groupId: getGroupID(),
    name: '',
    propertyId: '',
    sessionTimeoutInSeconds: 600,
    defaultLanguage: 'en-US',
    userName: '',
    password: '',
    hotelId: '',
    clientId: '',
    clientSecret: '',
    gatewayUrl: '',
    features: [],
    codes: [{ text: '', code: '', type: '' }],
  });
  const [reservationList, setReservationList] = useState(
    ReservationIntegrationsData
  );
  const [preCheckinList, setPreCheckinList] = useState(PreCheckinRequestData);
  const [houseKeepingList, setHouseKeepingList] = useState(HouseKeepingData);
  const [RegformList, setRegformList] = useState(RegformData);
  const [selectedReservationList, setSelectedReservationList] = useState([]);
  const [selectedPreCheckinList, setSelectedPreCheckinList] = useState([]);
  const [selectedHouseKeepingList, setSelectedHouseKeepingList] = useState([]);
  const [selectedRegFormList, setSelectedRegFormList] = useState([]);
  const [alertData, setAlertData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);

  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_OracleOpera_Integration}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          // console.log(res.data)
          setInputData({
            ...inputData,
            name: res.data.name,
            propertyId: res.data.properties[0],
            userName: res.data.channelDetails.userName,
            password: res.data.channelDetails.password,
            hotelId: res.data.channelDetails.hotelId,
            clientId: res.data.channelDetails.clientId,
            clientSecret: res.data.channelDetails.clientSecret,
            features: res.data.channelDetails.features,
            codes: res.data.channelDetails.codes,
            gatewayUrl: res.data.channelDetails.gatewayUrl,
          });
          LoadAlertCode();
          if (
            res.data.channelDetails.features !== null &&
            res.data.channelDetails.features.length > 0
          ) {
            var selectedreservation = [];
            selectedreservation = reservationList.map((elem) => {
              var exist = res.data.channelDetails.features.filter(
                (item) => item === elem.value
              );
              if (exist.length > 0) {
                elem.checked = true;
              } else {
                elem.checked = false;
              }
              return {
                ...elem,
              };
            });
            setReservationList(selectedreservation);

            const reservationArr = selectedreservation
              .filter((elem) => elem.checked === true)
              .map((elem) => elem.value);
            setSelectedReservationList(reservationArr);
            var selectedprecheckin = [];
            selectedprecheckin = preCheckinList.map((elem) => {
              var exist = res.data.channelDetails.features.filter(
                (item) => item === elem.value
              );
              if (exist.length > 0) {
                elem.checked = true;
              } else {
                elem.checked = false;
              }
              return {
                ...elem,
              };
            });
            setPreCheckinList(selectedprecheckin);
            const precheckinArr = selectedprecheckin
              .filter((elem) => elem.checked === true)
              .map((elem) => elem.value);
            setSelectedPreCheckinList(precheckinArr);

            var selectedhouseKeeping = [];
            selectedhouseKeeping = houseKeepingList.map((elem) => {
              var exist = res.data.channelDetails.features.filter(
                (item) => item === elem.value
              );
              if (exist.length > 0) {
                elem.checked = true;
              } else {
                elem.checked = false;
              }
              return {
                ...elem,
              };
            });
            setHouseKeepingList(selectedhouseKeeping);
            const housekeepingArr = houseKeepingList
              .filter((elem) => elem.checked === true)
              .map((elem) => elem.value);
            setSelectedHouseKeepingList(housekeepingArr);

            var selectedRegform = [];
            selectedRegform = RegformList.map((elem) => {
              var exist = res.data.channelDetails.features.filter(
                (item) => item === elem.value
              );
              if (exist.length > 0) {
                elem.checked = true;
              } else {
                elem.checked = false;
              }
              return {
                ...elem,
              };
            });
            setRegformList(selectedRegform);
            const regArr = RegformList.filter(
              (elem) => elem.checked === true
            ).map((elem) => elem.value);
            setSelectedRegFormList(regArr);
          } else {
            var selectedreservation = [];
            var selectedprecheckin = [];
            var selectedhouseKeeping = [];
            var selectedRegform = [];
            selectedreservation = reservationList.map((elem) => {
              if (elem.checked) {
                elem.checked = false;
              }
              return { ...elem };
            });
            selectedprecheckin = preCheckinList.map((elem) => {
              if (elem.checked) {
                elem.checked = false;
              }
              return { ...elem };
            });
            selectedhouseKeeping = houseKeepingList.map((elem) => {
              if (elem.checked) {
                elem.checked = false;
              }
              return { ...elem };
            });
            selectedRegform = RegformList.map((elem) => {
              if (elem.checked) {
                elem.checked = false;
              }
              return { ...elem };
            });
            setReservationList(selectedreservation);
            setPreCheckinList(selectedprecheckin);
            setHouseKeepingList(selectedhouseKeeping);
            setRegformList(selectedRegform);
          }
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
      setReservationList(ReservationIntegrationsData);
      setPreCheckinList(PreCheckinRequestData);
      setHouseKeepingList(HouseKeepingData);
      setRegformList(RegformData);
    }
  }, [id]);

  const LoadAlertCode = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_OracleOpera_Integration}/${id}/alert-department-codes?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setAlertData(res.data.alertList);
        setDepartmentData(res.data.departmentList);
      })
      .catch((err) => console.log('err', err));
  };
  const handleChange = (e) => {
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };
  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setInputData({ ...inputData, propertyId: e.target.value });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, propertyId: '' });
    }
  };

  const handleChecked = (e) => {
    if (e.target.name === 'reservation') {
      const values = reservationList.map((elem) => {
        if (elem.value === e.target.value) {
          elem.checked = !elem.checked;
        }
        return {
          ...elem,
        };
      });
      setReservationList(values);
      const langArr = values
        .filter((elem) => elem.checked === true)
        .map((elem) => elem.value);
      setSelectedReservationList(langArr);
    } else if (e.target.name === 'precheckin') {
      const values = preCheckinList.map((elem) => {
        if (elem.value === e.target.value) {
          elem.checked = !elem.checked;
        }
        return {
          ...elem,
        };
      });
      setPreCheckinList(values);
      const langArr = values
        .filter((elem) => elem.checked === true)
        .map((elem) => elem.value);
      setSelectedPreCheckinList(langArr);
    } else if (e.target.name === 'housekeeping') {
      const values = houseKeepingList.map((elem) => {
        if (elem.value === e.target.value) {
          elem.checked = !elem.checked;
        }
        return {
          ...elem,
        };
      });
      setHouseKeepingList(values);
      const langArr = values
        .filter((elem) => elem.checked === true)
        .map((elem) => elem.value);
      setSelectedHouseKeepingList(langArr);
    } else if (e.target.name === 'regform') {
      const values = RegformList.map((elem) => {
        if (elem.value === e.target.value) {
          elem.checked = !elem.checked;
        }
        return {
          ...elem,
        };
      });
      setRegformList(values);
      const langArr = values
        .filter((elem) => elem.checked === true)
        .map((elem) => elem.value);
      setSelectedRegFormList(langArr);
    }
  };
  const handleSave = async () => {
    var bodyData = {
      ...inputData,
      features: selectedReservationList.concat(
        selectedPreCheckinList,
        selectedHouseKeepingList,
        selectedRegFormList
      ),
    };
    if (id !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${API_OracleOpera_Integration}/${id}?group_id=${getGroupID()}`,
        data: bodyData,
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300)
        }
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: API_OracleOpera_Integration,
        data: bodyData,
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300)
        }
      });
    }
  };
  const handleChangeAlert = (e, item) => {
    const values = [...inputData.codes];
    var secondIndex = values.findIndex(
      (i) => i.text === item && i.type === e.target.name
    );
    if (secondIndex !== -1) {
      values[secondIndex].code = e.target.value;
    } else {
      values.push({
        text: item,
        code: e.target.value,
        type: e.target.name,
      });
    }
    setInputData({
      ...inputData,
      codes: values,
    });
  };

  const GetAltertDropdownList = (item) => {
    return (
      <Input
        type="select"
        value={inputData.codes
          .filter((i) => i.text === item && i.type === 'Alert')
          .map((elem) => elem.code)}
        name={'Alert'}
        onChange={(e) => handleChangeAlert(e, item)}
      >
        <option value="0">Select Alert Code</option>
        {alertData !== undefined &&
          alertData.map((item, i) => (
            <option value={item.code}>
              {item.code} - {item.name}
            </option>
          ))}
      </Input>
    );
  };
  const GetDepartmentDropdownList = (item) => {
    return (
      <Input
        type="select"
        value={inputData.codes
          .filter((i) => i.text === item && i.type === 'Department')
          .map((elem) => elem.code)}
        name={'Department'}
        onChange={(e) => handleChangeAlert(e, item)}
      >
        <option value="0">Select Department Code</option>
        {departmentData !== undefined &&
          departmentData.map((item, i) => (
            <option value={item.code}>
              {item.code} - {item.name}
            </option>
          ))}
      </Input>
    );
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? 'Add' : 'Update'} Integration</h6>
              </div>
              <Separator className="mb-3" />
              <Form>
                <Row>
                  <Colxx md="12">
                    <FormGroup className="mb-2">
                      <Label>Integration Name</Label>
                      <Input
                        type="text"
                        name="name"
                        onChange={handleChange}
                        placeholder="Integration Name"
                        defaultValue={inputData.name}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md="6">
                    <FormGroup className="mb-2">
                      <Label>User Name</Label>
                      <Input
                        type="text"
                        name="userName"
                        onChange={handleChange}
                        placeholder="User Name"
                        defaultValue={inputData.userName}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md="6">
                    <FormGroup className="mb-2">
                      <Label>Password</Label>
                      <Input
                        type="text"
                        name="password"
                        onChange={handleChange}
                        placeholder="Password"
                        defaultValue={inputData.password}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md="6">
                    <FormGroup className="mb-2">
                      <Label>Hotel Id</Label>
                      <Input
                        type="text"
                        name="hotelId"
                        onChange={handleChange}
                        placeholder="Hotel Id"
                        defaultValue={inputData.hotelId}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md="6">
                    <FormGroup className="mb-2">
                      <Label>Client Id</Label>
                      <Input
                        type="text"
                        name="clientId"
                        onChange={handleChange}
                        placeholder="Client Id"
                        defaultValue={inputData.clientId}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md="12">
                    <FormGroup className="mb-2">
                      <Label>Client Secret</Label>
                      <Input
                        type="text"
                        name="clientSecret"
                        onChange={handleChange}
                        placeholder="Client Secret"
                        defaultValue={inputData.clientSecret}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md="12">
                    <FormGroup className="mb-2">
                      <Label>Gateway Url</Label>
                      <Input
                        type="text"
                        name="gatewayUrl"
                        onChange={handleChange}
                        placeholder="Gateway Url"
                        defaultValue={inputData.gatewayUrl}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx md="12">
                    <FormGroup>
                      <div className="my-2 text-center">
                        <h3>Select your property</h3>
                      </div>
                      <div className="integration-property">
                        {sortPropertyListByName(property).map((p, index) => {
                          return (
                            <CustomInput
                              key={p.id}
                              type="radio"
                              id={index}
                              label={p.name}
                              value={p.id}
                              name="property"
                              checked={
                                p.id === inputData.propertyId ? true : false
                              }
                              onChange={handleCheckChange}
                            />
                          );
                        })}
                      </div>
                    </FormGroup>
                  </Colxx>
                  {id !== undefined && (
                    <Colxx md="12">
                      <FormGroup>
                        <div className="text-center">
                          <h3>Select features to enable</h3>
                        </div>
                        <Row>
                          <Colxx md="12">
                            <Label className="mt-3">
                              Reservation Integrations
                            </Label>
                            {reservationList.map((p, index) => {
                              return (
                                <CustomInput
                                  key={index}
                                  type="checkbox"
                                  id={index}
                                  label={p.label}
                                  value={p.value}
                                  name="reservation"
                                  checked={p.checked}
                                  onChange={handleChecked}
                                />
                              );
                            })}
                          </Colxx>
                          <Colxx md="12">
                            <Label className="mt-3">
                              For Pre-Check In Requests
                            </Label>
                            {preCheckinList.map((p, index) => {
                              return (
                                <Row key={index}>
                                  <Colxx md="6">
                                    <CustomInput
                                      key={index}
                                      type="checkbox"
                                      id={index}
                                      label={p.label}
                                      value={p.value}
                                      name="precheckin"
                                      checked={p.checked}
                                      onChange={handleChecked}
                                    />
                                  </Colxx>
                                  <Colxx md="6" className="mb-2">
                                    {p.checked &&
                                      p.value === 'pre_check_in_alert'
                                      ? GetAltertDropdownList(p.value)
                                      : p.checked &&
                                        p.value === 'pre_check_in_trace'
                                        ? GetDepartmentDropdownList(p.value)
                                        : null}
                                  </Colxx>
                                </Row>
                              );
                            })}
                          </Colxx>
                          <Colxx md="12">
                            <Label className="mt-3">
                              For HouseKeeping Requests
                            </Label>
                            {houseKeepingList.map((p, index) => {
                              return (
                                <Row>
                                  <Colxx md={6}>
                                    <CustomInput
                                      key={index}
                                      type="checkbox"
                                      id={index}
                                      label={p.label}
                                      value={p.value}
                                      name="housekeeping"
                                      checked={p.checked}
                                      onChange={handleChecked}
                                    />
                                  </Colxx>
                                  <Colxx md="6" className="mb-2">
                                    {p.checked &&
                                      p.value === 'house_keeping_alert'
                                      ? GetAltertDropdownList(p.value)
                                      : p.checked &&
                                        p.value === 'house_keeping_trace'
                                        ? GetDepartmentDropdownList(p.value)
                                        : null}
                                  </Colxx>
                                </Row>
                              );
                            })}
                          </Colxx>
                          <Colxx md="12">
                            <Label className="mt-3">For Reg Form</Label>
                            {RegformList.map((p, index) => {
                              return (
                                <Row>
                                  <Colxx md={12}>
                                    <CustomInput
                                      key={index}
                                      type="checkbox"
                                      id={index}
                                      label={p.label}
                                      value={p.value}
                                      name="regform"
                                      checked={p.checked}
                                      onChange={handleChecked}
                                    />
                                  </Colxx>
                                </Row>
                              );
                            })}
                          </Colxx>
                        </Row>
                      </FormGroup>
                    </Colxx>
                  )}
                </Row>
              </Form>
              <div className="text-center">
                <ButtonGroup
                  className="mb-2 text-center"
                  style={{ marginTop: '20px' }}
                >
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}

                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
